import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["shouldAnimateTranslations", "slidePosition", "children"];
import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
import { PHOTO_CAROUSEL_SLIDE_POSITIONS } from '../../constants';
import { StyledPhotoCarouselSlide } from './PhotoCarouselSlide.styles';

/**
 * Displays an individual item in a Photo Carousel.
 *
 * Renders up to three items: the item being displayed, the previous item and the next item.
 *
 * @since 8.66.0
 */

export var PhotoCarouselSlide = /*#__PURE__*/forwardRef(function (_ref, forwardedRef) {
  var shouldAnimateTranslations = _ref.shouldAnimateTranslations,
    slidePosition = _ref.slidePosition,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(StyledPhotoCarouselSlide, _extends({
    "aria-hidden": slidePosition !== PHOTO_CAROUSEL_SLIDE_POSITIONS.CENTER,
    ref: forwardedRef,
    shouldAnimateTranslations: shouldAnimateTranslations,
    slidePosition: slidePosition
  }, rest), children);
});
PhotoCarouselSlide.displayName = 'PhotoCarouselSlide';
PhotoCarouselSlide.propTypes = {
  /**
   * The content to display inside of the slide.
   */
  children: PropTypes.node,
  /**
   * If true, the sliding animation is enabled.
   */
  shouldAnimateTranslations: PropTypes.bool,
  /**
   * Photo Carousel only renders up to three slides at a time. This prop dictates
   * where this slide is located. The center slide is the one currently visible.
   */
  slidePosition: PropTypes.oneOf(Object.values(PHOTO_CAROUSEL_SLIDE_POSITIONS)).isRequired
};
PhotoCarouselSlide.defaultProps = {
  shouldAnimateTranslations: true
};